import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdAdminPanelSettings, MdKey, MdCheckCircle } from "react-icons/md";
import { setAdminAuth } from "../../../redux/reducers/userSlice";
import CommonFreeTextInput from "../../../components/common/inputs/CommonFreeTextInput";

function WhitelistAdminAuth({ callback }) {
  const dispatch = useDispatch();
  const storedAuth = useSelector((state) => state.user.adminAuth);

  const [localAuth, setLocalAuth] = useState(storedAuth || "");

  const isValid = !!String(localAuth || "").trim();

  const handleSet = async () => {
    if (!isValid) return;
    dispatch(setAdminAuth(localAuth));
    callback && (await callback(localAuth));
  };

  return (
    <div className="w-full rounded-2xl border border-outline bg-white p-4 md:p-6 shadow-sm">
      {/* Header */}
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
            <MdAdminPanelSettings className="text-primary text-xl" />
          </div>
          <div className="flex flex-col min-w-0">
            <span className="font-semibold text-gray-900">
              Admin authorization
            </span>
            <span className="text-sm text-gray-500 truncate">
              Enter admin token used to whitelist domains
            </span>
          </div>
        </div>

        {/* Status */}
        <div
          className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold ${
            isValid
              ? "bg-green-50 text-green-700 border border-green-100"
              : "bg-gray-50 text-gray-600 border border-gray-100"
          }`}
        >
          {isValid ? (
            <MdCheckCircle className="text-base" />
          ) : (
            <MdKey className="text-base" />
          )}
          {isValid ? "Ready" : "Not set"}
        </div>
      </div>

      {/* Input + Action */}
      <div className="flex flex-col md:flex-row gap-3 w-full">
        <div className="flex flex-1 min-w-0">
          <CommonFreeTextInput
            className="w-full"
            value={localAuth}
            onChange={(v) => setLocalAuth(v)}
          />
        </div>

        <div className="flex items-stretch md:items-end">
          <button
            type="button"
            disabled={!isValid}
            onClick={handleSet}
            className={`h-12 px-5 rounded-xl font-bold text-sm flex items-center justify-center gap-2 transition ${
              isValid
                ? "bg-primary1 text-white hover:opacity-90"
                : "bg-primary/10 text-primary cursor-not-allowed"
            }`}
          >
            <MdKey className="text-lg" />
            Set
          </button>
        </div>
      </div>

      {/* Stored indicator */}
      {!!storedAuth && (
        <div className="mt-4 rounded-xl border border-outline bg-gray-50 px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <MdCheckCircle className="text-green-600 text-lg shrink-0" />
            <span className="text-sm text-gray-700 truncate">
              Admin auth stored
            </span>
          </div>
          <span className="text-xs text-gray-500">••••••••</span>
        </div>
      )}
    </div>
  );
}

export default WhitelistAdminAuth;
